import { call, put, retry, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import * as TYPES from "./actionTypes";
import * as ACTIONS from "./actions";
import * as API from "helpers/backend_helper";

import toastr from "toastr";

import {errorMsg, successMsg} from "helpers/toastr";

function* assetWidrawSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(API.assetWithdrawAPI, data)
    callback && callback(response)
    if (response.status === "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.assetWithdrawFail(response.message))
    }

    yield put(ACTIONS.assetWithdrawSuccess(response));
  } catch (error) {
    yield put(ACTIONS.assetWithdrawFail(error.message))
  }
}


function* assetWidrawHistory({ payload: { data, callback } }) {
  try {
    const response = yield call(API.assetWithdrawHistory, data)
    callback && callback(response)
    if (response.status === "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.withdrawHistoryFail(response.message))
    }

    yield put(ACTIONS.withdrawHistorySuccess(response));
  } catch (error) {
    yield put(ACTIONS.withdrawHistoryFail(error.message))
  }
}


function* transactionsHistory({ payload: { data, callback } }) {
  try {
    const response = yield call(API.apiTransactionHistory, data)
    callback && callback(response)
    if (response.status === "failure") {
      errorMsg(response.message)
      return yield put(ACTIONS.transactionHistoryFail(response.message))
    }

    yield put(ACTIONS.transactionHistorySuccess(response));
  } catch (error) {
    yield put(ACTIONS.transactionHistoryFail(error.message))
  }
}
function* walletSaga() {

  yield takeEvery(TYPES.POST_ASSET_WITHDRAW,assetWidrawSaga)
  yield takeEvery(TYPES.GET_WITHDRAW_HISTORY,assetWidrawHistory)
  yield takeEvery(TYPES.TRANSACTION_HISTORY, transactionsHistory);


}

export default walletSaga;
